export default __webpack_public_path__ + "static/media/hat.e8786a9e.png";